import { render, staticRenderFns } from "./AmFileButton.vue?vue&type=template&id=d80b07fc&scoped=true&"
import script from "./AmFileButton.vue?vue&type=script&lang=js&"
export * from "./AmFileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80b07fc",
  null
  
)

export default component.exports